import React from "react";

export default function Synonyms(props) {
  if (props.data) {
    return (
      <div>
        <h2>Synonyms: </h2>

        {props.data.map(function (synonym, index) {
          return <span key={index}>{synonym} | </span>;
        })}
      </div>
    );
  } else {
    return null;
  }
}
